/* BAU REGALI — bau-premio.js v4.0
   La UI viene renderizzata direttamente dal cart-drawer Liquid.
   Questo file sostituisce la vecchia logica "Premio aggiunto" e
   resta volutamente leggero per non interferire con bau-cart.js. */
(function () {
  'use strict';
  window.BauPremio = {
    version: '4.0',
    init: function () {}
  };
})();
